import React, {Component} from "react";

import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
/*
    For Redux, need to import connect and action
    Redux connect is to access Redux
    Redux action to update the state of the form field
*/
import { connect } from "react-redux"
import { updateForm } from "../../store/actions/FormAction";

class ReloanSlider extends Component {
  constructor(){
    super();
    this.handleLoanChange = this.handleLoanChange.bind(this);
  }

  componentDidMount() {
    this.props.updateForm("loanamt", this.props.maxamt);
    this.props.updateForm("askedforamt", this.props.maxamt);
  }

  handleLoanChange = value => {
    this.props.updateForm("loanamt", value);
    this.props.updateForm("askedforamt", value);
  };

  render() {
      // this.props.loanamt returns a string so need to parseInt
      // providing default 10 as radix
      let loanamt = parseInt(this.props.loanamt, 10);
      let minamt = parseInt(this.props.minamt, 10);
      let maxamt = parseInt(this.props.maxamt, 10);
      const loanamountLabels = {
        0: '$'+this.props.minamt,
        100: '$'+this.props.maxamt
      };

      return (
          <label>
            <div className="loanamount text-center">
              <input type="text" id="amount" readOnly="readonly" value={"$"+loanamt} style={{border:0,boxShadow:'none'}}/>
            </div>
            <div className='slider custom-labels'>
              <div className='slider-group'>
                <div className='slider-horizontal'>
                  <Slider
                    min={minamt}
                    max={maxamt}
                    step={25}
                    tooltip={false}
                    value={loanamt}
                    labels={loanamountLabels}
                    handleLabel={"$"+loanamt}
                    onChange={this.handleLoanChange}
                  />
                </div>
              </div>
              <div className="text-center">
                <small>Use the slider to choose your loan amount.</small>
              </div>
            </div>
          </label>
        );
    }
}

const mapStateToProps = (state) => ({
    minamt: state.FormReducer.minamt,
    maxamt: state.FormReducer.maxamt,
    loanamt: state.FormReducer.loanamt
})

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
})
/*
    Can put mapStateToProps or state => ({}) as first param of connect()
    Using mapStateToProps for simplicity and stylistic preference
*/
export default connect(mapStateToProps, mapDispatchToProps)(ReloanSlider)



// WEBPACK FOOTER //
// ./src/components/partials/ReloanSlider.js